import { getErrorMessage } from "../getErrorMessage";
import type { DateRange, Validator } from "./types";

export const dateRange: Validator = ({
  name,
  answer,
  validation,
  questionErrorMessage,
}) => {
  const { futureOnly, minDays, maxDays } = validation.value as DateRange;

  const invalid = () => ({
    id: name,
    valid: false,
    message: getErrorMessage({
      validationMessage: validation.message,
      questionErrorMessage,
    }),
  });

  if (futureOnly) {
    const today = new Date().toISOString().split("T")[0];
    const date = new Date(answer).toISOString().split("T")[0];

    if (date < today) {
      return invalid();
    }
  }

  if (minDays) {
    const today = new Date();
    const date = new Date(answer);
    const minDate = new Date(today.setDate(today.getDate() + minDays));

    if (date < minDate) {
      return invalid();
    }
  }

  if (maxDays) {
    const today = new Date();
    const date = new Date(answer);
    const maxDate = new Date(today.setDate(today.getDate() + maxDays));

    if (date > maxDate) {
      return invalid();
    }
  }

  return {
    id: name,
    valid: true,
  };
};
